import { render, staticRenderFns } from "./StepRegistration.vue?vue&type=template&id=681721b1&scoped=true&"
import script from "./StepRegistration.vue?vue&type=script&lang=ts&"
export * from "./StepRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681721b1",
  null
  
)

export default component.exports